<template functional>
  <div class="sku-header">{{ props.name }} {{ props.skuFormat }}</div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    skuFormat: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.sku-header {
  @include text(0.3rem, #262626, bold);
  @include text-overflow-ellipsis-single;
}
</style>
